import axios from 'axios'
import { getAPIService } from '../../../getServerHost'

export const getDeviceDetail = async (payload: number) => {
  const response = await axios.get(`${getAPIService}/v2/api/ip-devices/devices/${payload}`)
  return response.data
}
